import { html } from "@nodusjs/std/dom";

export const component = (icon) => html`${icon.use}`;
